import styled from "styled-components";

export const H1 = styled.div`
  font-size: 40px;
  font-family: "Pretendard", sans-serif;
  color: var(--text-primary);
  font-weight: bold;
`;

export const H2 = styled.div`
  font-size: 30px;
  font-family: "Pretendard", sans-serif;
  color: var(--text-primary);
  font-weight: bold;
`;

export const H3 = styled.div`
  font-size: 24px;
  font-family: "Pretendard", sans-serif;
  color: var(--text-primary);
  font-weight: bold;
`;

export const H4 = styled.div`
  font-size: 20px;
  font-family: "Pretendard", sans-serif;
  color: var(--text-primary);
  font-weight: 600;
`;

export const H5 = styled.div`
  font-size: 16px;
  font-family: "Pretendard", sans-serif;
  color: var(--text-primary);
  font-weight: 600;
`;

export const B1 = styled.div`
  font-size: 20px;
  font-family: "Pretendard", sans-serif;
  color: var(--text-primary);
`;

export const B2 = styled.div`
  font-size: 18px;
  font-family: "Pretendard", sans-serif;
  color: var(--text-primary);
`;

export const B3 = styled.div`
  font-size: 16px;
  font-family: "Pretendard", sans-serif;
  color: var(--text-primary);
  white-space: pre-wrap;
`;

export const B4 = styled.div`
  font-size: 14px;
  font-family: "Pretendard", sans-serif;
  color: var(--text-primary);
`;

export const B5 = styled.div`
  font-size: 12px;
  font-family: "Pretendard", sans-serif;
  color: var(--text-primary);
`;
